import { RouteError } from '@akyga/shared-ui/RouteError';

export default RouteError;
